import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/auth';
import { allMenu } from './config';
import ChatService from 'services/chat';
import { io } from 'socket.io-client';
import { socket_url } from 'config';

const SOCKET_OPTIONS = {
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 8000,
  timeout: 20000,
};

const useMenu = ({
  showMenu = false,
  onCloseMenu,
  accountMenu,
  workspaceName,
  userFirstName,
} = {}) => {
  const [menuItems, setMenuItems] = useState([]);
  const [chatUnreadCount, setChatUnreadCount] = useState(0);
  const navigate = useNavigate();
  const { user } = useAuth();
  const socketRef = useRef(null);
  const serviceRef = useRef(new ChatService());

  const refreshChatUnread = useCallback(async () => {
    try {
      const threads = await serviceRef.current.listThreads({ page: 1, page_size: 50 });
      const total = (threads || []).reduce((sum, item) => sum + Number(item?.unread_shop || 0), 0);
      setChatUnreadCount(total);
    } catch (error) {
      setChatUnreadCount(0);
    }
  }, []);

  useEffect(() => {
    refreshChatUnread();
  }, [refreshChatUnread]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const socket = io(socket_url, {
      ...SOCKET_OPTIONS,
      auth: { token },
    });

    socketRef.current = socket;
    socket.on('chat:thread_updated', () => {
      refreshChatUnread();
    });
    socket.on('reconnect', () => {
      refreshChatUnread();
    });
    socket.on('connect_error', () => {
      // socket.io will retry automatically
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [refreshChatUnread]);

  const menuTemplate = useMemo(() => {
    return allMenu.map((item) => {
      if (item.key !== '/chats') {
        return item;
      }

      return {
        ...item,
        badgeCount: chatUnreadCount,
      };
    });
  }, [chatUnreadCount]);

  useEffect(() => {
    const wp = user.work_space;
    const permissions = wp.permissions ?? [];

    let items = [...menuTemplate];
    if (!['admin', 'owner'].includes(wp.role)) {
      items = items.filter((menu) => {
        if (!menu.permission) {
          return true;
        }

        if (permissions.includes(menu.permission)) {
          return true;
        }

        console.log('wp', wp);
        if (wp.role === menu.role) {
          return true;
        }

        return false;
      });
    }

    setMenuItems(items);
  }, [user, menuTemplate]);

  const menuClick = useCallback((e) => {
    if (onCloseMenu) {
      onCloseMenu();
    }
    navigate(e.key);
  }, [navigate, onCloseMenu]);

  return {
    menuItems,
    menuClick,
    showMenu,
    onCloseMenu,
    accountMenu,
    workspaceName,
    userFirstName,
  };
};

export default useMenu;
